import * as React from 'react';

import {NavIconChevronLeftIcon} from 'shells/icon/navigation/nav-icon-chevron-left';
import {NavIconChevronRightIcon} from 'shells/icon/navigation/nav-icon-chevron-right';

import {useSidebarCollapse} from './use-sidebar-collapse';

type Props = {
    userId: string | null | undefined;
    isSidebarCollapsed: boolean;
};

export function CollapseSidebarButton(props: Props) {
    const setSidebarCollapsed = useSidebarCollapse();

    return (
        <button
            onClick={() =>
                props.userId && setSidebarCollapsed(props.userId, !props.isSidebarCollapsed)
            }
            className={`nut-sidebar--collapse-button ${
                props.isSidebarCollapsed ? 'nut-sidebar--collapse-button--collapsed' : ''
            }`}
        >
            {props.isSidebarCollapsed ? (
                <NavIconChevronRightIcon size={12} wrapWithDiv={false} />
            ) : (
                <NavIconChevronLeftIcon size={12} wrapWithDiv={false} />
            )}
        </button>
    );
}
